import React, { useState, useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

// Pages
import DefaultPage from "pages/LoginOrRegisterPages/LoginOrRegisterPages";
import LoggingOutPage from "pages/LoggingOutPage/LoggingOutPage";
import RegistrationPages from "pages/RegistrationPages/RegistrationPages";
import TwoFactorRegisterPages from "pages/TwoFactorRegisterPages/TwoFactorRegisterPages";

// Tools
import initProductTools from "./utils/productTools/index";

// Redux
import { useSelector } from "react-redux";

export default function App() {
  const [pageTitle, setPageTitle] = useState("Log in | Octopus Investments");
  const { pathname } = useLocation();
  const { isAmpliLoaded } = useSelector(({ application }) => application);

  useEffect(() => {
    if (pathname === "/mfa/register")
      setPageTitle("Octopus Investments Portal | MFA");
  }, [pathname]);

  !isAmpliLoaded && initProductTools();

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <Switch>
        <Route path="/logout" component={LoggingOutPage} />
        <Route path="/(signup|reset-password)/:email/:token" component={RegistrationPages} />
        <Route path="/mfa/register" component={TwoFactorRegisterPages} />
        <Route path="*" component={DefaultPage} />
      </Switch>
    </>
  );
}
